import React from 'react';

export default function CPUCell({ cpu }: { cpu: number }) {
	return <div>{cpu.toFixed(2)}s</div>;
}
